import { lazy } from 'react';
import { retry } from '../../config/utils';

const ChangePassword = lazy(() =>  retry(()=> import(/* webpackChunkName: "change-password" */ "./index")));

export default ChangePassword;